<section class="error-wrapper ">
    <f-alert variant="error"
        [ngClass]="rootScope.isGENSYSErrorToHide ? 'hide' : 'hide1'">{{rootScope.errorMsg}}</f-alert>
    <f-alert variant="error"
        [ngClass]="rootScope.isGensysUDPErrorToHide ? 'hide' : 'hide1'">{{rootScope.errorMsg}}</f-alert>
    <f-alert variant="warning" [ngClass]="isWarningToHide ? 'hide' : 'hide1'" is-dismissable="true"
        (dismiss)="closeWarning()">{{rootScope.warningMsg}}</f-alert>
    <f-alert variant="error" [ngClass]="isErrorToHide ? 'hide' : 'hide1'">{{rootScope.errorMsg}}</f-alert>
    <f-alert variant="info" [ngClass]="isInfoToHide ? 'hide' : 'hide1'">{{rootScope.infoMsg}}</f-alert>
    <f-alert variant="success" [ngClass]="isSuccessToHide ? 'hide' : 'hide1'">{{rootScope.successMsg}}</f-alert>

</section>